<template>
  <div class="exam-tip-container">
    <div class="title">
      Tip
    </div>
    <span v-html="examTip" />
  </div>
</template>

<script>
export default {
  props: {
    examTip: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang='scss' scoped>
  .exam-tip-container {
    background: #f2f4f7;
    padding: rem-calc(12);
    margin: rem-calc(20) 0;
    border-radius: 8px;
  }
  .title {
    color: #000000;
    font-size: rem-calc(20);
    font-weight: $bold;
    margin-bottom: rem-calc(8);
  }
</style>
